import React, { useContext, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../Context/GlobalState";
import { Col, Row } from "react-bootstrap";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { basicauth } from "../Utils/Credentials";

const Domainpage = () => {
  const [url, setUrl] = useState("");
  const [url1, setUrl1] = useState("");
  const [loading, setLoading] = useState(false);
  const formatDomainInput = (input) => {
    if (!input.startsWith("https://") && !input.startsWith("http://")) {
      return `https://${input}`;
    }
    return input;
  };
  const [seoData1, setSeoData1] = useState(null);
  const [seoData, setSeoData] = useState(null);
  const fetchData = async () => {
    setLoading(true);
    const formattedUrl = formatDomainInput(url);

    try {
      const response = await fetch(

        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/GetDomainAge`,
       {
          method: "POST",
         headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ domainName: formattedUrl, type: "1" }),
        }
      );

      const data = await response.json();
      setSeoData(data.data[0]);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching domain data:", error);
    }
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const fetchData1 = async () => {
    const uuid = generateUUID();
    const formattedUrl = formatDomainInput(url1);

    setLoading(true);
    try {
      const response = await fetch(
       `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchSiteMetrics`,
        {
          method: "POST",
         headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formattedUrl,
            scope: "domain",
            type: "1",
          }),
        }
      );

      const data = await response.json();
      if (
        data.status === "0" &&
        data.msg === "Success" &&
        data.data.length > 0
      ) {
        setSeoData1(data.data[0]);
        setLoading(false);
      } else {
        console.log("Site metrics not found in response");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching domain data:", error);
      setLoading(false);
    }
  };

  return (
    <Row className="d-flex justify-content-center mt-2 mx-2">
      {/* <Col md={10}> */}{loading && (
        <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(255,255,255,0.8)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            width: "60px",
            height: "60px",
            border: "6px solid #f3f3f3",
            borderTop: "6px solid #007bff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    )}
      <div className="row justify-content-center mt-4 mb-5 pb-5">
        <div className="col-12 col-md-6 mb-3 mb-md-0 p-0">
          <div
            className="card h-100"
            style={{ border: "#fff", borderRadius: ".6rem" }}
          >
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">Domain Authority Checker</h5>
              <p className="card-text">
              Quickly analyze a domain’s authority, page strength, keyword rankings, and leading competitors in just one click.

              </p>
              <div className="mt-auto w-100">
                <div className="position-relative d-none d-sm-block">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Domain"
                    value={url1}
                    onChange={(e) => setUrl1(e.target.value)}
                    style={{
                      borderRadius: "50px",
                      height: "3rem",
                    }}
                  />
                  <button
                    type="submit"
                    className="btn position-absolute"
                    onClick={fetchData1}
                    style={{
                      top: "50%",
                      right: "0.5rem",
                      transform: "translateY(-50%)",
                      borderRadius: "5rem",
                      padding: "4px 12px",
                      background: "transparent",
                      border: "2px solid #007bff",
                      color: "#333",
                      fontWeight: 500,
                      fontSize: ".9rem",
                      cursor: "pointer",
                    }}
                  >
                    Check for free
                  </button>
                </div>

                <div className="d-block d-sm-none mt-2">
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter Domain"
                    value={url1}
                    onChange={(e) => setUrl1(e.target.value)}
                    style={{
                      borderRadius: "50px",
                      height: "3rem",
                    }}
                  />
                  <button
                    type="submit"
                    className="btn w-100"
                    onClick={fetchData1}
                    style={{
                      borderRadius: "5rem",
                      padding: "8px 12px",
                      border: "2px solid #007bff",
                      color: "#333",
                      fontWeight: 500,
                      fontSize: ".9rem",
                      background: "transparent",
                    }}
                  >
                    Check for free
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mt-md-0 mt-2">
          <div
            className="card h-100"
            style={{ border: "#fff", borderRadius: ".6rem" }}
          >
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">Domain Age Checker</h5>
              <p className="card-text">
                Domain age checker can help you determine a website’s history
                within seconds. Just enter the URL to quickly find out how long
                a site has been online and assess its reliability!
              </p>
              <div className="mt-auto w-100">
                <div className="position-relative d-none d-sm-block">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Domain"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    style={{
                      borderRadius: "50px",
                      height: "3rem",
                    }}
                  />
                  <button
                    type="submit"
                    className="btn position-absolute"
                    onClick={fetchData}
                    style={{
                      top: "50%",
                      right: "0.5rem",
                      transform: "translateY(-50%)",
                      borderRadius: "5rem",
                      padding: "4px 12px",
                      background: "transparent",
                      border: "2px solid #007bff",
                      color: "#333",
                      fontWeight: 500,
                      fontSize: ".9rem",
                      cursor: "pointer",
                    }}
                  >
                    Check for free
                  </button>
                </div>

                <div className="d-block d-sm-none mt-2">
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter Domain"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    style={{
                      borderRadius: "50px",
                      height: "3rem",
                    }}
                  />
                  <button
                    type="submit"
                    className="btn w-100"
                    onClick={fetchData}
                    style={{
                      borderRadius: "5rem",
                      padding: "8px 12px",
                      border: "2px solid #007bff",
                      color: "#333",
                      fontWeight: 500,
                      fontSize: ".9rem",
                      background: "transparent",
                    }}
                  >
                    Check for free
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {seoData1 && (
          <div className="col-12 mt-2">
            <div
              className="card"
              style={{ border: "#fff", borderRadius: ".6rem" }}
            >
              <h5
                className="pt-3 d-flex justify-content-center flex-wrap text-center"
                style={{ color: "#757d8c" }}
              >
                Domain Information for&nbsp;
                <div style={{ color: "#f53c73", fontWeight: "bold" }}>
                  {seoData1.url}
                </div>
              </h5>

              <div
                className="card-body p-0 d-flex flex-column flex-md-row justify-content-between align-items-center m-2"
                style={{ background: "#fff", borderRadius: "1rem" }}
              >
                <div
                  className="text-center p-2 flex-fill border-md-end"
                  style={{
                    borderRight: "none",
                    borderRightColor: "#cdd3d3",
                    borderRightStyle: "solid",
                  }}
                >
                  <h5>Domain Authority (DA)</h5>
                  <p style={{ color: "#f53c73", fontSize: "2.2rem" }}>
                    {seoData1.da}%
                  </p>
                </div>

                <div
                  className="text-center p-2 flex-fill border-md-end"
                  style={{
                    borderRight: "none",
                    borderRightColor: "#cdd3d3",
                    borderRightStyle: "solid",
                  }}
                >
                  <h5>Page Authority (PA)</h5>
                  <p style={{ color: "#f53c73", fontSize: "2.2rem" }}>
                    {seoData1.pa}%
                  </p>
                </div>

                <div className="text-center p-2 flex-fill">
                  <h5>Spam Score</h5>
                  <p style={{ color: "#f53c73", fontSize: "2.2rem" }}>
                    {seoData1.spam_score}%
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {seoData && (
          <div className="col-12 mt-2">
            <div
              className="card"
              style={{ border: "#fff", borderRadius: ".6rem" }}
            >
              <h5
                className="pt-3 d-flex justify-content-center flex-wrap text-center"
                style={{ color: "#757d8c" }}
              >
                Domain Age for&nbsp;
                <div style={{ color: "#f53c73", fontWeight: "bold" }}>
                  {seoData.domainName}
                </div>
              </h5>

              <div
                className="card-body p-0 d-flex flex-column flex-md-row justify-content-between align-items-center m-2"
                style={{ background: "#fff", borderRadius: "1rem" }}
              >
                <div className="text-center p-2 flex-fill border-md-end">
                  <h6>Age</h6>
                  <p style={{ color: "#f53c73", fontSize: "1.2rem" }}>
                    {seoData ? seoData.estimatedDomainAge : "-"}
                  </p>
                </div>

                <div className="text-center p-2 flex-fill border-md-end">
                  <h6>Created On</h6>
                  <p style={{ color: "#f53c73", fontSize: "1.2rem" }}>
                    {seoData?.createdDate
                      ? new Date(seoData.createdDate).toLocaleDateString(
                          "en-GB",
                          {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          }
                        )
                      : "-"}
                  </p>
                </div>

                <div className="text-center p-2 flex-fill border-md-end">
                  <h6>Updated On</h6>
                  <p style={{ color: "#f53c73", fontSize: "1.2rem" }}>
                    {seoData
                      ? new Date(seoData.updatedDate)
                          .toLocaleString("en-GB", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })
                          .replace(",", "")
                      : "-"}
                  </p>
                </div>

                <div className="text-center p-2 flex-fill">
                  <h6>Expire Date</h6>
                  <p style={{ color: "#f53c73", fontSize: "1.2rem" }}>
                    {seoData
                      ? new Date(seoData.expiresDate)
                          .toLocaleString("en-GB", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })
                          .replace(",", "")
                      : "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* </Col> */}
    </Row>
  );
};

export default Domainpage;
